import CityPageTemplate from "../city-template/CityPageTemplate";
import { miamiConfig } from "./data";

export default function MiamiPage() {
  return <CityPageTemplate config={miamiConfig} />;
}